export const C = {
  or: '#E8602E',
  orLt: '#FEF2EC',
  orBd: '#F4C5B0',
  orMid: '#F0A882',
  ink: '#18120F',
  ink2: '#3C3028',
  ink3: '#7B6E65',
  ink4: '#B9AFA8',
  sf: '#FFFFFF',
  sf2: '#F8F5F1',
  sf3: '#F0EBE5',
  bd: '#E5DDD6',
  gr: '#187A56',
  grLt: '#E6F5EE',
  grBd: '#A8DFC5',
  rd: '#C93535',
  rdLt: '#FCEAEA',
  rdBd: '#F0C0C0',
  am: '#B87200',
  amLt: '#FEF3E0',
  amBd: '#F0D090',
  bl: '#2460A7',
  blLt: '#E8F0FB',
  blBd: '#C3D9F5',
  te: '#0F7B8C',
  teLt: '#E5F5F7',
};

export const S = {
  sh1: '0 1px 3px rgba(24,18,15,.05)',
  sh2: '0 4px 12px rgba(24,18,15,.08)',
  sh3: '0 12px 32px rgba(24,18,15,.12)',
};
